import React, { Component } from 'react'
// legacy/workaround: this stylesheet was only loaded via Suite/MoreDetails.js;
// now that MoreDetails is scoped, this remaining consumer owns the import
import '../Suite/AddSigneePopup.scss';

export default class ContactMoreDetails extends Component {
    render() {
        const { closePopup, details } = this.props;        
        return (
            <div className='moreDetailspopupBg'>
                <div className='popupMain'>
                <div className='heddingPopup'>
                    <h4>Information</h4>
                </div>
                    <div onClick={closePopup} className='closePopup'><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                    </svg></div>
                    <div className='popupContent'>
                    {details.rating_name &&
                        <div className='contentText'>
                            <p className='fw-600'>Rating name</p>
                            <p>{details.rating_name}</p>
                        </div>}
                        {details.full_name &&
                            <div className='contentText'>
                                <p className='fw-600'>Full name</p>
                                <p>{details.full_name}</p>
                            </div>}
                            {details.rating_id &&  
                        <div className='contentText'>
                            <p className='fw-600'>Rating id</p>
                            <p>{details.rating_id}</p>
                        </div>}
                        {details.country_name &&  
                        <div className='contentText'>
                            <p className='fw-600'>Country name</p>
                        <p>{details.country_name}</p>
                        </div>}
                        {details.country_id &&  
                        <div className='contentText'>
                            <p className='fw-600'>Country id</p>
                            <p>{details.country_id}</p>
                        </div>}
                        {details.contact_preference &&  
                        <div className='contentText'>
                            <p className='fw-600'>contact preference</p>
                            <p>{details.contact_preference}</p>
                        </div>}
                       
                </div>
            </div>
            </div>
        )
    }
}

